import { useState, useEffect } from "react";
import {
  Card,
  Table,
  Tag,
  Switch,
  Select,
  Input,
  Space,
  Button,
  Modal,
  Spin,
  message,
  Form,
  Row,
  Col,
  Typography,
  Divider,
  Popconfirm,
} from "antd";
import type { ColumnsType } from "antd/es/table";
import Header from "../../components/Header/header";
import * as Actions from "../../store/slices/templateMapping/templateMapping"
import { connect } from "react-redux";
import styles from './templatemapping.module.css';
import { hasPermission } from "../../utils/premission";
import { PERMISSIONS } from "../../utils/constant/permissions";
import { useNavigate } from 'react-router-dom';



interface Api {
  Template_Red: any;
  getAllTemp: (params: { page: number; size: number }) => void;
  CreateTemplate: (payload: any) => void;
  GetTemplateById: (id: number) => unknown;
  DeleteTemplate: (id: number) => unknown;
  UpdateTemplate: (payload: any) => unknown;
  getAllDbField: () => unknown
}

const { Title } = Typography;

interface TemplateMapping {
  id: number;
  csvTemplateId: number;
  csvFieldName: string;
  dbFieldName: string;
  defaultValue?: string;
  fixedValue?: string;
}

interface CsvTemplate {
  id: number;
  templateName: string;
  description: string;
  isActive: boolean;
  templateDetails: TemplateMapping[];
}

// const dummyTemplates: CsvTemplate[] = [
//   {
//     id: 1,
//     templateName: "Customer Import 2025",
//     description: "Standard customer data import from marketing team",
//     isActive: true,
//     templateDetails: [
//       { id: 1, csvTemplateId: 1, csvFieldName: "Full Name", dbFieldName: "name", defaultValue: "", fixedValue: "" },
//       { id: 2, csvTemplateId: 1, csvFieldName: "Email Address", dbFieldName: "email", defaultValue: "", fixedValue: "" },
//       { id: 3, csvTemplateId: 1, csvFieldName: "Phone", dbFieldName: "phone_number", defaultValue: "N/A", fixedValue: "" },
//     ],
//   },
// ];

const TemplateMappingPage: React.FC<Api> = ({ DeleteTemplate, Template_Red, getAllTemp, CreateTemplate, GetTemplateById, UpdateTemplate, getAllDbField }) => {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState<CsvTemplate[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState<CsvTemplate | null>(null);
  const [dbFields, setDbFields] = useState<{ dbFieldName: string; displayFieldName: string }[]>([]);
  const [form] = Form.useForm();
  const [tableLoading, setTableLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [newMapping, setNewMapping] = useState<Partial<TemplateMapping>>({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState<number>(0);




  useEffect(() => {
    setTableLoading(true);
    getAllDbField();
  }, [getAllTemp]);


  useEffect(() => {
    setTableLoading(true);
    getAllTemp({ page: currentPage - 1, size: pageSize });
  }, [currentPage, pageSize, getAllTemp]);


  useEffect(() => {
    if (Template_Red?.getdbfield[0]?.res) {
      setDbFields(Template_Red?.getdbfield[0]?.res);
    }
  }, [Template_Red]);


  console.log('Template_Red full object:', Template_Red);
  console.log('templates state:', templates);



  useEffect(() => {
    if (Template_Red?.data?.length > 0) {
      const response = Template_Red.data[0]?.res;
      
      if (response?.status === '1004') {
        message.error(response.message);
        localStorage.clear();
        navigate('/');
        setTableLoading(false);
      } else if (response?.status === '1005') {
        message.warning(response.message);
        setTemplates([]);
        setTableLoading(false);
      } else if (Array.isArray(response?.content)) {
        setTemplates(response.content);
        setTotal(response.totalElements || 0);
        setTableLoading(false);
      } else if (Array.isArray(response)) {
        setTemplates(response);
        setTotal(response.length);
        setTableLoading(false);
      } else {
        console.log('Unexpected data structure:', response);
        setTemplates([]);
        setTableLoading(false);
      }
    } else if (Template_Red?.error) {
      message.error(Template_Red.error || "Failed to load templates");
      setTemplates([]);
      setTableLoading(false);
    }
  }, [Template_Red, navigate]);








  useEffect(() => {
    if (editingTemplate) {
      form.setFieldsValue({
        templateName: editingTemplate.templateName,
        description: editingTemplate.description,
        isActive: editingTemplate.isActive,
      });
    } else {
      form.resetFields();
    }
  }, [editingTemplate, form]);






  const columns: ColumnsType<CsvTemplate> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Template Name",
      dataIndex: "templateName",
      key: "templateName",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
    },
    {
      title: "Mappings",
      key: "mappings",
      render: (_, record) => (
        <Tag color="blue">
          {record.templateDetails?.length ?? 0} fields
        </Tag>
      ),
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (active: boolean) => (
        <Tag color={active ? "success" : "error"}>
          {active ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 140,
      render: (_, record) => (
        <Space>
          {hasPermission(PERMISSIONS.CSV_TEMPLATE_UPDATE) && (

            <Button
              size="small"
              onClick={() => handleEdit(record)}
            >
              Edit
            </Button>
          )}
          <Popconfirm
            title="Delete template"
            description="Are you sure you want to delete this mapping template?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            {hasPermission(PERMISSIONS.CSV_TEMPLATE_DELETE) && (
              <Button size="small" danger>
                Delete
              </Button>
            )}
          </Popconfirm>
        </Space>
      ),
    },
  ];







  const handleAddNew = () => {
    setEditingTemplate(null);
    form.setFieldsValue({
      templateDetails: [],   // 🔥 REQUIRED
      isActive: true,
    });
    setIsModalOpen(true);
  };



  // const handleEdit = (template: CsvTemplate) => {
  //   setEditingTemplate(template);
  //   setIsModalOpen(true);
  // };

  const handleDelete = async (id: number) => {
    Modal.confirm({
      title: 'Delete Template',
      content: 'Are you sure you want to delete this template? This action cannot be undone.',
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      centered: true,
      maskClosable: false,
      onOk: async () => {
        setTableLoading(true);

        try {
          await DeleteTemplate(id);

          message.success('Template deleted successfully');

          window.location.reload()
          getAllTemp({
            page: currentPage - 1,
            size: pageSize,
          });


          if (editingTemplate?.id === id) {
            setIsModalOpen(false);
            form.resetFields();
            setEditingTemplate(null);
          }
        } catch (error: any) {
          console.error('Failed to delete template:', error);
          message.error(
            error?.message || 'Failed to delete template. Please try again.'
          );
        } finally {
          setTableLoading(false);
        }
      },
    });
  };





  const handleModalOk = async () => {
    try {
      setModalLoading(true);

      const values = await form.validateFields();

      const templateDetailsClean = (values.templateDetails || []).map(
        ({ csvFieldName, dbFieldName, defaultValue, fixedValue }: any) => ({
          csvFieldName,
          dbFieldName,
          defaultValue: defaultValue || "",
          fixedValue: fixedValue || "",
        })
      );

      const payload = {
        id: editingTemplate ? editingTemplate.id : null,
        templateName: values.templateName,
        description: values.description,
        isActive: values.isActive ?? true,
        templateDetails: templateDetailsClean,
      };

      let res: any;
      if (editingTemplate) {
        res = await UpdateTemplate(payload);
        if (res?.success === false) {
          message.error(res?.message || "Update failed");
          return;
        }
        message.success("Template updated successfully");
      } else {
        res = await CreateTemplate(payload);
        message.success("Template created successfully");
        setCurrentPage(1);
      }

      setIsModalOpen(false);
      form.resetFields();
      setEditingTemplate(null);
      getAllTemp({ page: currentPage - 1, size: pageSize });
    } catch (err: any) {
      message.error(err?.message || "Operation failed");
    } finally {
      setModalLoading(false);
    }
  };

  const handleEdit = async (template: CsvTemplate) => {
    setModalLoading(true);

    try {
      const res: any = await GetTemplateById(template.id);

      if (res?.success) {
        const data = res.data;

        setEditingTemplate(data);

        form.setFieldsValue({
          templateName: data.templateName,
          description: data.description,
          isActive: data.isActive,
          templateDetails: data.templateDetails || [],
        });

        setIsModalOpen(true);
        message.success("Template loaded successfully");
      } else {
        message.error(res?.message || "Failed to load template");
      }
    } catch (err) {
      message.error("Something went wrong while loading template");
    } finally {
      setModalLoading(false);
    }
  };



  const handleTableChange = (pagination: any) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };



  return (
    <>
      <Header />
      <div className={styles.container}>
        <div style={{ marginBottom: 16 }}>
          <Title level={4}>File / Template Mapping</Title>
        </div>

        <Card bordered={false}>
          <Space style={{ marginBottom: 16 }}>
            {hasPermission(PERMISSIONS.CSV_TEMPLATE_CREATE) && (

              <Button type="primary" onClick={handleAddNew}>
                Create New Template
              </Button>
            )}
          </Space>

          <Table
            columns={columns}
            dataSource={templates}
            rowKey="id"
            loading={tableLoading}
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              total: total,                        // ← crucial: from server
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
              showTotal: (totalCount, range) =>
                `${range[0]}-${range[1]} of ${totalCount} templates`,
              onChange: (page, size) => {
                setCurrentPage(page);
                setPageSize(size);
              },
            }}
            onChange={handleTableChange}
          />
        </Card>

        <Modal
          title={editingTemplate ? "Edit Template" : "Create New Template"}
          open={isModalOpen}
          onOk={handleModalOk}
          confirmLoading={modalLoading}
          onCancel={() => {
            setIsModalOpen(false);
            form.resetFields();
          }}
          okText={editingTemplate ? "Save Changes" : "Create"}
          width={700}
        >
          <Spin spinning={modalLoading}>
            <Form form={form} layout="vertical">
              <Row gutter={16}>
                <Col span={16}>
                  <Form.Item
                    name="templateName"
                    label="Template Name"
                    rules={[{ required: true, message: "Please enter template name" }]}
                  >
                    <Input placeholder="e.g. Customer Import 2025" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="isActive" label="Status" valuePropName="checked">
                    <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item name="description" label="Description">
                <Input.TextArea rows={2} placeholder="Purpose of this mapping..." />
              </Form.Item>

              <Divider orientation="left">Field Mappings (to be implemented)</Divider>


              {/* <Divider orientation="left">Field Mappings</Divider> */}

              <Form.List name="templateDetails">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name }) => (
                      <Row gutter={12} key={key} align="middle">
                        <Col span={6}>
                          <Form.Item
                            name={[name, "csvFieldName"]}
                            rules={[{ required: true, message: "CSV field required" }]}
                          >
                            <Input placeholder="CSV Field" />
                          </Form.Item>
                        </Col>

                        <Col span={12}>
                          <Form.Item
                            name={[name, "dbFieldName"]}
                            rules={[{ required: true, message: "Please select database field" }]}
                          >
                            <Select
                              placeholder="Select DB field"
                              showSearch
                              optionFilterProp="label"
                              filterOption={(input, option) =>
                                String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                              }
                              disabled={modalLoading}
                            >
                              {dbFields.map((field) => (
                                <Select.Option
                                  key={field.dbFieldName}
                                  value={field.dbFieldName}
                                  label={field.displayFieldName}
                                >
                                  {field.displayFieldName} ({field.dbFieldName})
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col span={4}>
                          <Form.Item name={[name, "defaultValue"]}>
                            <Input placeholder="Default" />
                          </Form.Item>
                        </Col>

                        <Col span={4}>
                          <Form.Item name={[name, "fixedValue"]}>
                            <Input placeholder="Fixed" />
                          </Form.Item>
                        </Col>

                        <Col span={2}>
                          <Button danger disabled={modalLoading} onClick={() => remove(name)}>
                            X
                          </Button>
                        </Col>
                      </Row>
                    ))}

                    <Button
                      type="dashed"
                      block
                      onClick={() => add()}
                      disabled={modalLoading}
                    >
                      + Add Mapping
                    </Button>
                  </>
                )}
              </Form.List>
            </Form>
          </Spin>

        </Modal>
      </div>
    </>
  );
}

function mapStateToProps(state: any) {
  return {
    Template_Red: state.Template_Red
  }
}

export default connect(mapStateToProps, Actions)(TemplateMappingPage);